import BlogPostPage from './BlogPostPage';

export default BlogPostPage;
